import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    SimpleChanges,
    OnChanges,
    ViewChild
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {IntegrationServices} from '../../../../shared/services/src/api';
import {StringUtils} from '../../../../shared';
import {ValidatorUtils} from '../../../../shared/utils/src/validator.utils';
import {using} from 'rxjs/observable/using';
import { IntegrationType } from '../../../../shared/enums/integration-type.enum';
import {
    IntegrationDetailLabel,
    IntegrationName
} from '../../../../views/main/integration/integration.config';
import {TranslateService} from '@ngx-translate/core';
@Component({
    selector: 'jira-rule-component',
    templateUrl: './jira-rule.component.html'
})

export class JiraRuleComponent implements OnInit, OnDestroy, OnChanges  {
    @Input() detailRuleUseFlag: any;

    @Input() set nowItgrCallbackInfo(value: any) {
        this.setNowItgrCallbackInfo(value);
    }

    // 상위 컴포넌트에서 이거 수정가능한지 설정해줄 때 쓰는 변수
    @Input() public isEditable: boolean;
    @Input() public itgrNo: number;
    @Input() public itgrApplInstlNo: number;
    @ViewChild('eventRuleSet') eventRuleSet: any;
    @ViewChild('issueRuleSet') issueRuleSet: any;

    _nowItgrCallBackInfo: any;
    IntegrationType = IntegrationType;

    public itgrCallbackInfo = {
        itgrAttrs: [],
        ruleInfo: [],
    };

    public jiraConfig: any = {
        url: '',
        urlAttrNo: '',
        projectKey: '',
        pjtKeyAttrNo: '',
        issueType: '',
        iTyAttrNo: '',
        user: '',
        userAttrNo: '',
        apiKey: '',
        apiKeyAttrNo: ''
    };

    // ruleInfo
    ruleInfo: any;

    // ruleInfo 중 IRTY10 인 경우
    eventRuleInfo = {
        itgrApplRuleNo: '',
        useYn: 'Y',
        itgrRuleTypeCd: 'IRTY10',
        ruleCnfgInfo: []
    };
    eventRuleCnfgInfo = [];
    eventRuleUseFlag = true;

    // ruleInfo 중 IRTY20 인 경우
    issueRuleInfo = {
        itgrApplRuleNo: '',
        useYn: 'Y',
        itgrRuleTypeCd: 'IRTY20',
        ruleCnfgInfo: [],
    };
    issueRouteRuleInfo: any = {
        cndInfo: [],
    };
    issueRuleCnfgInfo = [];
    issueRuleUseFlag = true;

    // jira validation 관련
    isEmptyURL = false;
    isInvalidURL = false;
    isEmptyPjtKey = false;
    isEmptyIssueType = false;
    isEmptyUserNm = false;
    isEmptyApiKey = false;
    isProjectKeyExists = false;
    isCheckingProjectKey = false;

    isUseRoutCnd = false;

    private projectKeyValidationSubject = new Subject<string>();

    constructor(
        private _integrationServices: IntegrationServices,
        private translate: TranslateService,
    ) {
    }

    ngOnInit() {
        if (typeof this._nowItgrCallBackInfo !== 'undefined'
            && this._nowItgrCallBackInfo.hasOwnProperty('itgrAttrs')) {
            this.setConfig(this._nowItgrCallBackInfo);
        }

        this.projectKeyValidationSubject
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe(projectKey => {
                this.validateProjectKey(projectKey);
            });
    }

    ngOnDestroy() {
        if (this.projectKeyValidationSubject) {
            this.projectKeyValidationSubject.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        const useFlag = changes['detailRuleUseFlag'];
        if (useFlag && useFlag.currentValue === true) {
            this.eventRuleUseFlag = this.issueRuleUseFlag = true;
        }
        const chng = changes['nowItgrCallbackInfo'];
        if (chng && this._nowItgrCallBackInfo.hasOwnProperty('itgrAttrs')) {
            this.setConfig(this._nowItgrCallBackInfo);
        }
    }

    init() {
        this.jiraConfig = {
            url: '',
            urlAttrNo: '',
            projectKey: '',
            pjtKeyAttrNo: '',
            issueType: '',
            iTyAttrNo: '',
            user: '',
            userAttrNo: '',
            apiKey: '',
            apiKeyAttrNo: ''
        }
        this.isEmptyURL = false;
        this.isInvalidURL = false;
        this.isEmptyUserNm = false;
        this.isEmptyApiKey = false;
        this.isEmptyPjtKey = false;
        this.isEmptyIssueType = false;
        this.isProjectKeyExists = false;
        this.isCheckingProjectKey = false;
    }

    // 화면에서 룰 설정된 값 가져올 때
    getItgrCallbackInfo() {
        this.itgrCallbackInfo.itgrAttrs = [{
            itgrApplInstlAttrNo : this.jiraConfig.urlAttrNo,
            attrNm : 'URL',
            attrVal : this.jiraConfig.url
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.pjtKeyAttrNo,
            attrNm : 'PROJECT_KEY',
            attrVal : this.jiraConfig.projectKey
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.iTyAttrNo,
            attrNm : 'ISSUE_TYPE',
            attrVal : this.jiraConfig.issueType
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.userAttrNo,
            attrNm : 'USER',
            attrVal : this.jiraConfig.user
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.apiKeyAttrNo,
            attrNm : 'PASSWORD',
            attrVal : this.jiraConfig.apiKey
        }];
        if (this.eventRuleUseFlag) {
            this.itgrCallbackInfo.ruleInfo.push(this.eventRuleSet.getRuleInfo());
        }

        if (this.issueRuleUseFlag && this.issueRuleSet) {
            this.itgrCallbackInfo.ruleInfo.push(this.issueRuleSet.getRuleInfo());
        }
        return this.itgrCallbackInfo;
    }

    // 사용자가 등록했던 룰 정보 가져와서 화면에 세팅할 때
    setNowItgrCallbackInfo(data) {
        if (typeof data === 'object' && Object.keys(data).length > 0) {
            this._nowItgrCallBackInfo = data;
            this.ruleInfo = this._nowItgrCallBackInfo.ruleInfo;

            const issueRuleInfo = this.ruleInfo.find( r => r.itgrRuleTypeCd === 'IRTY20')

            if (issueRuleInfo && issueRuleInfo.routRuleInfo && issueRuleInfo.routRuleInfo.ruleRoutGrpInfo[0]) {
                this.issueRouteRuleInfo = issueRuleInfo.routRuleInfo.ruleRoutGrpInfo[0]
                this.issueRouteRuleInfo.procRuleNo = issueRuleInfo.routRuleInfo.procRuleNo;
                this.issueRouteRuleInfo.useYn = issueRuleInfo.routRuleInfo.useYn;
            }

            // 초기화
            this.eventRuleUseFlag = false;
            this.issueRuleUseFlag = false;

            for (const rule of this.ruleInfo) {
                this.setUseRule(rule);
            }
        } else {
            this._nowItgrCallBackInfo = [];
        }
    }

    // 룰 별로 사용 여부 체크 및 값 넣어줌
    setUseRule(rule) {
        const ruleType = rule.itgrRuleTypeCd;
        switch (ruleType) {
            case 'IRTY10':
                this.eventRuleInfo = rule;
                this.eventRuleCnfgInfo = rule.ruleCnfgInfo;
                for (const ruleCnfg of this.eventRuleCnfgInfo) {
                    ruleCnfg.itgrRuleTypeCd = ruleType;
                }
                if (rule['useYn'] === 'Y') {
                    this.detailRuleUseFlag = true;
                    this.eventRuleUseFlag = true;
                } else {
                    this.eventRuleUseFlag = false;
                }
                break;
            case 'IRTY20':
                this.issueRuleInfo = rule;
                this.issueRuleCnfgInfo = rule.ruleCnfgInfo;
                for (const ruleCnfg of this.issueRuleCnfgInfo) {
                    ruleCnfg.itgrRuleTypeCd = ruleType;
                }
                if (rule['useYn'] === 'Y') {
                    this.detailRuleUseFlag = true;
                    this.issueRuleUseFlag = true;
                } else {
                    this.issueRuleUseFlag = false;
                }
                break;
        }
    }


    // 룰 설정에 필요한 정보 가져오기
    public setConfig(info) {
        const itgrAttrs = info['itgrAttrs'];
        const ruleInfo = info['ruleInfo'];

        for (const itgrAttr of itgrAttrs) {
            const attrNm = itgrAttr['attrNm'];
            const attrVal = itgrAttr['attrVal'];
            const itgrApplInstlAttrNo = itgrAttr['itgrApplInstlAttrNo'];

            switch (attrNm) {
                case 'URL':
                    this.jiraConfig.urlAttrNo = itgrApplInstlAttrNo;
                    this.jiraConfig.url = attrVal;
                    this.isEmptyURL = false;
                    this.isInvalidURL = false;
                    this.isProjectKeyExists = false;
                    this.isCheckingProjectKey = false;
                    if (this.jiraConfig.projectKey && this.itgrNo === IntegrationType.JIRA_SOFTWARE) {
                        this.onProjectKeyChange(this.jiraConfig.projectKey);
                    }
                    break;
                case 'PROJECT_KEY':
                    this.jiraConfig.pjtKeyAttrNo = itgrApplInstlAttrNo;
                    this.jiraConfig.projectKey = attrVal;
                    this.isEmptyPjtKey = false;
                    break;
                case 'ISSUE_TYPE':
                    this.jiraConfig.iTyAttrNo = itgrApplInstlAttrNo;
                    this.jiraConfig.issueType = attrVal;
                    this.isEmptyIssueType = false;
                    break;
                case 'USER':
                    this.jiraConfig.userAttrNo = itgrApplInstlAttrNo;
                    this.jiraConfig.user = attrVal;
                    this.isEmptyUserNm = false;
                    break;
                case 'PASSWORD':
                    this.jiraConfig.apiKeyAttrNo = itgrApplInstlAttrNo;
                    this.jiraConfig.apiKey = attrVal;
                    this.isEmptyApiKey = false;
                    break;
            }
        }

        for (const rule of ruleInfo) {
            this.setUseRule(rule);
        }
    }

    // 사용자가 수정한 값을 내보내기
    public updateConfig(detailUseFlag: boolean) {
        const itgrCallbackInfo = {
            itgrAttrs: [],
            ruleInfo: [],
        };

        // 아예 상세설정을 사용하지 않을 때 useYn을 N으로 값 변경해서 보내야함
        if (!detailUseFlag) {
            const validRuleInfo = (typeof  this.ruleInfo !== 'undefined' && this.ruleInfo.length > 0);
            if (validRuleInfo) {
                for (const rule of this.ruleInfo) {
                    const newRule = {
                        itgrApplRuleNo: rule['itgrApplRuleNo'],
                        useYn: 'N'
                    };
                    itgrCallbackInfo.ruleInfo.push(newRule);
                }
            }

            return itgrCallbackInfo;
        }

        // 상세 설정을 사용할 때
        itgrCallbackInfo.itgrAttrs = [{
            itgrApplInstlAttrNo : this.jiraConfig.urlAttrNo,
            attrNm : 'URL',
            attrVal : this.jiraConfig.url
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.pjtKeyAttrNo,
            attrNm : 'PROJECT_KEY',
            attrVal : this.jiraConfig.projectKey
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.iTyAttrNo,
            attrNm : 'ISSUE_TYPE',
            attrVal : this.jiraConfig.issueType
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.userAttrNo,
            attrNm : 'USER',
            attrVal : this.jiraConfig.user
        }, {
            itgrApplInstlAttrNo : this.jiraConfig.apiKeyAttrNo,
            attrNm : 'PASSWORD',
            attrVal : this.jiraConfig.apiKey
        }];

        if (this.eventRuleUseFlag) {
            const detailEventRuleInfo = this.eventRuleSet.getRuleInfo();
            const eventRule = {
                itgrApplRuleNo: this.eventRuleInfo.itgrApplRuleNo,
                useYn: 'Y',
                itgrRuleTypeCd: detailEventRuleInfo.itgrRuleTypeCd,
                ruleCnfgInfo: detailEventRuleInfo.ruleCnfgInfo
            };
            itgrCallbackInfo.ruleInfo.push(eventRule);
        } else {
            const eventRule = {
                itgrApplRuleNo: this.eventRuleInfo.itgrApplRuleNo,
                useYn: 'N',
            };
            itgrCallbackInfo.ruleInfo.push(eventRule);
        }

        if (this.issueRuleUseFlag) {
            const detailIssueRuleInfo = this.issueRuleSet.getRuleInfo();
            const routRuleInfo = this.getUpdateRoutRuleInfo(detailIssueRuleInfo.routRuleInfo);
            const updateRuleRoutGrpInfo = null;

            itgrCallbackInfo.ruleInfo.push({
                itgrApplRuleNo: this.issueRuleInfo.itgrApplRuleNo,
                useYn: 'Y',
                itgrRuleTypeCd: detailIssueRuleInfo.itgrRuleTypeCd,
                ruleCnfgInfo: detailIssueRuleInfo.ruleCnfgInfo,
                routRuleInfo,
            });
        } else {
            itgrCallbackInfo.ruleInfo.push({
                itgrApplRuleNo: this.issueRuleInfo.itgrApplRuleNo,
                useYn: 'N',
            });
        }

        // 추가 룰이 생성된다면 if문 + flag로
        return itgrCallbackInfo;
    }

    public validation(): boolean {
        let isValid = true;
        for (const key in this.jiraConfig) {
            if (!this.validChk(key)) {
                isValid = false;
                break;
            }
        }
        if (!this.eventRuleSet.isValidSelectData()) {
            isValid = false;
        }

        if (!this.useRuleValid()) {
            isValid = false;
        }

        if (this.issueRuleUseFlag && this.isUseRoutCnd && !this.routeRuleValid()) {
            isValid = false;
        }

        // if (this.itgrNo === IntegrationType.JIRA_SOFTWARE) {
        //     if (this.jiraConfig.projectKey && this.jiraConfig.url) {
        //         this.forceProjectKeyValidation(this.jiraConfig.projectKey);
        //     }

        //     if (this.isCheckingProjectKey) {
        //         isValid = false;
        //     }
        //     if (this.isProjectKeyExists) {
        //         isValid = false;
        //     }
        // }
        return isValid;
    }

    validChk(id) {
        let isValid = true;
        switch (id) {
            case 'url':
                if (StringUtils.isEmpty(this.jiraConfig.url)) {
                    this.isEmptyURL = true;
                    this.isInvalidURL = false;
                    isValid = false;
                } else if (!ValidatorUtils.checkURL(this.jiraConfig.url)) {
                    this.isEmptyURL = false;
                    this.isInvalidURL = true;
                    isValid = false;
                } else {
                    this.isEmptyURL = false;
                    this.isInvalidURL = false;
                    isValid = true;
                    if (this.jiraConfig.projectKey && this.itgrNo === IntegrationType.JIRA_SOFTWARE) {
                        this.onProjectKeyChange(this.jiraConfig.projectKey);
                    }
                }
                break;
            case 'projectKey':
                if (this.itgrNo !== IntegrationType.JIRA && StringUtils.isEmpty(this.jiraConfig.projectKey)) {
                    this.isEmptyPjtKey = true;
                    isValid = false;
                }  else {
                    this.isEmptyPjtKey = false;
                    this.onProjectKeyChange(this.jiraConfig.projectKey);
                }
                break;
            case 'issueType':
                if (this.itgrNo !== IntegrationType.JIRA && StringUtils.isEmpty(this.jiraConfig.issueType)) {
                    this.isEmptyIssueType = true;
                    isValid = false;
                }  else {
                    this.isEmptyIssueType = false;
                }
                break;
            case 'user':
                if (StringUtils.isEmpty(this.jiraConfig.user)) {
                    this.isEmptyUserNm = true;
                    isValid = false;
                }  else {
                    this.isEmptyUserNm = false;
                }
                break;
            case 'apiKey':
                if (StringUtils.isEmpty(this.jiraConfig.apiKey)) {
                    this.isEmptyApiKey = true;
                    isValid = false;
                }  else {
                    this.isEmptyApiKey = false;
                }
                break;
        }
        return isValid;
    }

    useRuleValid() {
        return !(!this.eventRuleUseFlag && !this.issueRuleUseFlag);
    }

    useOneRule(ruleType) {
       if(this.itgrNo === IntegrationType.JIRA){
          this.issueRuleUseFlag = false;
       }

       if(ruleType === 'eventRule'){
           return (this.eventRuleUseFlag && !this.issueRuleUseFlag);
       } else if (ruleType === 'issueRule') {
           return (!this.eventRuleUseFlag && this.issueRuleUseFlag);
       }

       return false;
    }

    routeRuleValid() {
        let returnValue = true;

        if (this.issueRuleSet) {
            const detailIssueRuleInfo = this.issueRuleSet.getRuleInfo();

            if(detailIssueRuleInfo && detailIssueRuleInfo.routRuleInfo && detailIssueRuleInfo.routRuleInfo.ruleRoutGrpInfo) {
                for (const info of detailIssueRuleInfo.routRuleInfo.ruleRoutGrpInfo) {
                    if(Array.isArray(info.cndInfo) && info.cndInfo.length) {

                        for (const item of info.cndInfo) {
                            if (StringUtils.isEmpty(item.cndVal)) {
                                item.isInvalidCndVal = true;
                            }
                            if (item.isInvalidCndVal) {
                                returnValue = false;
                                break;
                            }
                        }
                    }
                    if (!returnValue) {
                        break;
                    }
                }
            }
        }
        return returnValue;
    }

    getJiraRuleTitle() {
        return this.translate.instant('MK.01960', {
            integrationService:  this.translate.instant(IntegrationName[this.itgrNo])
        });
    }

    getJiraOtherRuleTitle() {
        return this.translate.instant('MK.01961', {
            integrationService:  this.translate.instant(IntegrationName[this.itgrNo])
        });
    }

    getUpdateRoutRuleInfo(routRuleInfo) {
        if (!routRuleInfo || routRuleInfo.useYn !== 'Y' || !routRuleInfo.ruleRoutGrpInfo || !Array.isArray(routRuleInfo.ruleRoutGrpInfo)) {
            return {
                procRuleNo: null,
                useYn: 'N',
            };
        }

        const returnValue = {
            procRuleNo: routRuleInfo.procRuleNo,
            ruleType: routRuleInfo.ruleType,
            useYn: routRuleInfo.useYn,
            ruleRoutGrpInfo: [],
        };

        if (routRuleInfo && routRuleInfo.ruleRoutGrpInfo && Array.isArray(routRuleInfo.ruleRoutGrpInfo)) {
            for (const grpInfo of routRuleInfo.ruleRoutGrpInfo) {
                returnValue.ruleRoutGrpInfo.push({
                    ruleRoutGrpNo: grpInfo.ruleRoutGrpNo,
                    ordrNo: grpInfo.ordrNo,
                    cnnTypeCd: grpInfo.cnnTypeCd,
                    cndLogicTypeCd: grpInfo.cndLogicTypeCd,
                    cndInfo: this.getUpdateCndInfo(grpInfo.cndInfo),
                });
            }
        }

        return returnValue;
    }

    getUpdateCndInfo(cndInfo) {
        const returnValue = [];

        for (const info of cndInfo) {
            returnValue.push({
                ruleCndCnfgNo: info.ruleCndCnfgNo,
                msgSpecFildNo: info.msgSpecFildNo,
                oprTypeCd: info.oprTypeCd,
                cndVal: info.cndVal,
                cndValSprtnChaVal: '',
                msgSpecFildList: info.msgSpecFildList,
            })
        }
        return returnValue;
    }

    isRoutCndUse(event) {
        this.isUseRoutCnd = event;
    }


    private validateProjectKey(projectKey: string) {

        if (!projectKey || !this.jiraConfig.url || this.itgrNo !== IntegrationType.JIRA_SOFTWARE) {
            this.isProjectKeyExists = false;
            this.isCheckingProjectKey = false;
            return;
        }

        this.isCheckingProjectKey = true;
        this.isProjectKeyExists = false;

        let excludeIntegrationNo: number | undefined;
        if (this.itgrApplInstlNo) {
            excludeIntegrationNo = this.itgrApplInstlNo;
        }

        this._integrationServices.checkJiraProjectKeyExists(projectKey, this.jiraConfig.url, excludeIntegrationNo)
            .then(response => {
                this.isCheckingProjectKey = false;
                if (response === true) {
                    this.isProjectKeyExists = true;
                } else {
                    this.isProjectKeyExists = false;
                }
            })
            .catch(error => {
                this.isCheckingProjectKey = false;
                this.isProjectKeyExists = false;
            });
    }

    onProjectKeyChange(projectKey: string) {
        this.projectKeyValidationSubject.next(projectKey);
    }

    forceProjectKeyValidation(projectKey: string) {
        this.validateProjectKey(projectKey);
    }

    async forceProjectKeyValidationAsync(): Promise<boolean> {
        if (this.itgrNo !== IntegrationType.JIRA_SOFTWARE) {
            return true;
        }
        if (!this.jiraConfig || !this.jiraConfig.projectKey || !this.jiraConfig.url) {
            return false;
        }

        this.isCheckingProjectKey = true;
        this.isProjectKeyExists = false;

        let excludeIntegrationNo: number | undefined;
        if (this.itgrApplInstlNo) {
            excludeIntegrationNo = this.itgrApplInstlNo;
        }

        try {
            const response = await this._integrationServices.checkJiraProjectKeyExists(this.jiraConfig.projectKey, this.jiraConfig.url, excludeIntegrationNo);
            this.isCheckingProjectKey = false;
            this.isProjectKeyExists = (response === true);
            return !this.isProjectKeyExists;
        } catch (e) {
            this.isCheckingProjectKey = false;
            this.isProjectKeyExists = false;
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/detail-rule/jira-rule/jira-rule.component.ts